// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2_G9Q","errorLogs":"EditorFooter_errorLogs__3ouqF"};